import { useEffect } from "react";

/**
 * Registro de ações críticas (teste em andamento, geração de IA...).
 * Cada consumidor recebe um token próprio; o app só fica "crítico" enquanto
 * existir algum token ativo. `end()` é idempotente — nunca prende o app.
 */
const active = new Set<symbol>();
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((l) => l());

export function beginCriticalAction(label = "critical"): () => void {
  const token = Symbol(label);
  active.add(token);
  notify();
  let ended = false;
  return () => {
    if (ended) return;
    ended = true;
    active.delete(token);
    notify();
  };
}

export function isCriticalActionActive(): boolean {
  return active.size > 0;
}

export function onCriticalActionChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Marca ação crítica enquanto `isActive` for true; libera sempre no unmount. */
export function useCriticalAction(isActive: boolean, label?: string) {
  useEffect(() => {
    if (!isActive) return;
    const end = beginCriticalAction(label);
    return end;
  }, [isActive, label]);
}
